import { ActionContext, ActionTree } from "vuex";

import RootState from "../../root-state";
import State from "./state";

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {};

export default actions;
